import { action } from 'src/store/actions';

export const FETCH_PARTNER_NO_PAYOUT_RATIONALES = 'FETCH_PARTNER_NO_PAYOUT_RATIONALES';
export const REQUEST_PARTNER_NO_PAYOUT_RATIONALES = 'REQUEST_PARTNER_NO_PAYOUT_RATIONALES';
export const SUCCESS_PARTNER_NO_PAYOUT_RATIONALES = 'SUCCESS_PARTNER_NO_PAYOUT_RATIONALES';
export const FAILURE_PARTNER_NO_PAYOUT_RATIONALES = 'FAILURE_PARTNER_NO_PAYOUT_RATIONALES';

export const fetchPartnerNoPayoutRationales = () => action(FETCH_PARTNER_NO_PAYOUT_RATIONALES);
export const requestPartnerNoPayoutRationales = () => action(REQUEST_PARTNER_NO_PAYOUT_RATIONALES);
export const requestPartnerNoPayoutRationalesSuccess = (response: any) =>
    action(SUCCESS_PARTNER_NO_PAYOUT_RATIONALES, { response });
export const requestPartnerNoPayoutRationalesFailure = (error: any) =>
    action(FAILURE_PARTNER_NO_PAYOUT_RATIONALES, { error });
